"use client";

import Link from "next/link";
import { useTranslations, useLocale } from "next-intl";
import { Header } from "@/components/root/header";
import { Footer } from "@/components/root/footer";
import { Button } from "@/components/ui/button";

export function NotFound() {
  const t = useTranslations("notFound");
  const locale = useLocale();

  return (
    <>
      <Header />
      <main>
        <div className="flex flex-col items-center justify-center h-[calc(100vh-300px)]">
          <h2 className="text-4xl text-gray-300 font-light mb-2">404</h2>
          <p className="text-4xl font-semibold mb-6">{t("title")}</p>
          <Button
            asChild
            className="bg-surface-foreground hover:bg-brand-accent text-white"
            size="lg"
          >
            <Link href={`/${locale}`}>{t("returnHome")}</Link>
          </Button>
        </div>
      </main>
      <Footer />
    </>
  );
}
